export default __webpack_public_path__ + "static/media/question-mark.02fddfba.jpg";